import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const styles = (theme) => ({
  container: {
    marginBottom: theme.spacing(8)
  },
  content: {
    width: 776,
    display: 'flex',
    alignItems: 'flex-end',
    ...condensedStyles(theme, { width: 'auto', flex: '1 1 480px', minWidth: 0, maxWidth: 776 })
  },
  title: {
    width: 348,
    ...condensedStyles(theme, { width: 'auto', flex: '0 1 348px', minWidth: 0 })
  },
  options: {
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
});

export default makeStyles(styles);
